const ServiceOffered = {
    Offered: {
        container: {
            width: '100%',
            borderRadius: '8px',
            boxShadow: '0 2px 24px 8px rgba(0, 92, 188, 0.12)',
            backgroundColor: '#fbfcfe',
            fontFamily: 'Inter, sans-serif',
            padding: '20px',
        },
        sectionsContainer: {
            display: 'flex',
            gap: '18px',
        },
        section: {
            flex: 1,
            minWidth: 0,
        },
        header: {
            display: 'flex',
            width: '100%',
            flexDirection: 'column',
            fontWeight: 700,
            justifyContent: 'center',
            marginBottom: '16px',
        },
        headerContent: {
            display: 'flex',
            width: '100%',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
        },
        title: {
            fontSize: '18px',
            color: '#3a3a3a',
            lineHeight: 1.4,
            margin: 0,
            fontWeight: 600,
        },
        buttonContainer: {
            display: 'flex',
            alignItems: 'center',
        },
        button: {
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            fontSize: '14px',
            color: '#005cbc',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: 0,
            textTransform: 'none',
            '&:hover': {
                backgroundColor: 'transparent',
                boxShadow: 'none',
            },
        },
        buttonIcon: {
            width: '16px',
            height: '16px',
        },
        servicesList: {
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gridTemplateRows: 'repeat(2, 1fr)',
            gap: '10px',
            width: '100%',
            minHeight: '200px',
            '@media (max-width: 768px)': {
                gridTemplateColumns: 'repeat(2, 1fr)',
                gridTemplateRows: 'repeat(4, 1fr)',
            },
            '@media (max-width: 480px)': {
                gridTemplateColumns: '1fr',
                gridTemplateRows: 'auto',
            },
        },
    },
    ServiceItem: {
        container: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            flex: 1,
            flexBasis: 'calc(8.333% - 12px)', // Ensure 12 items fit in a single row
            minWidth: '80px',
            cursor: 'pointer',
        },
        icon: {
            aspectRatio: '1',
            objectFit: 'contain',
            width: '40px',
        },
        name: {
            marginTop: '8px',
            fontSize: '14px',
            color: '#3a3a3a',
            fontWeight: 500,
            lineHeight: 1,
            breakWord: 'break-word',
            textAlign: 'center',
        },
    },
};

export default ServiceOffered;
